var modules_645d8c13 = {"card":"OfferCard_module_card__a6fbedc5","withBorder":"OfferCard_module_withBorder__a6fbedc5","clickable":"OfferCard_module_clickable__a6fbedc5"};
import "../../assets/esm/components/OfferCard/OfferCard~D8ujUeGb.css";

export { modules_645d8c13 as default };
//# sourceMappingURL=OfferCard.module.scss.js.map
